import React from 'react'

import {InputComponentProps} from './types'

import {Typography} from '~/components/general/typography/Typography'
import {Input} from '~/components/general/input/Input'
import {Container} from '~/components/general/container/Container'
import {StyledDashboardInnerCardTableCell} from '~/components/facility/GeneralDataCard.styled'

type TextDataInputProps = InputComponentProps & {
  inputType?: React.HTMLInputTypeAttribute
}

export const TextDataInput: React.FC<TextDataInputProps> = ({
  title,
  name,
  initialValue,
  inputType = 'text',
  disabled = false,
  currentData,
  onUpdate,
  required,
}) => {
  const [value, setValue] = React.useState<string>(initialValue || '')

  const handleValueChange = (newValue: string) => {
    setValue(newValue)
    onUpdate([{name, value: newValue}])
  }

  return (
    <StyledDashboardInnerCardTableCell>
      <Container direction="column">
        <Typography weight="medium" size="sm" required={required} inline>
          {title}
        </Typography>
        <Input
          type={inputType}
          size="small"
          placeholder="Enter value"
          disabled={
            typeof disabled === 'function' ? disabled(currentData) : disabled
          }
          value={value}
          onChange={(e) => handleValueChange(e.target.value)}
          required={required && !value.trim()}
        />
      </Container>
    </StyledDashboardInnerCardTableCell>
  )
}
